// @flow
// TODO: this file is an enum dedicated to list all the icons used in the project. The utils package
// should merge all the icons lists such as:
// - packages/b2c/src/client/components/utils/icon/icons.js (this file)
// - packages/b2c-cms-config/src/schema/pages/definitions/lines/product-strengths/productStrengths.icons.js
// - packages/graphql/src/schemas/category/icons.json
export const ICONS = {
  ACCESS_AGE: 'access-age',
  ACCOMODATIONS: 'accommodations',
  ACTIVITIES: 'activities',
  ADDRESS: 'address',
  ADVANCED_SKIING: 'advanced_skiing',
  ADVENTURE: 'adventure',
  ALL_INCLUSIVE: 'allInclusive',
  ANSWERS: 'answers',
  APRES_SKI: 'apres_ski',
  ARCHERY: 'archery',
  ARROW_FORTH: 'arrowForth',
  ARROW_WITH_SHADOW: 'arrowWithShadow',
  ARROW_WITH_TRAIL: 'arrowWithTrail',
  BABY_CLUB: 'babyClub',
  BADMINTON: 'badminton',
  BAGGAGE: 'baggage',
  BAR: 'barsAndRestaurants',
  BAR_CODE: 'barcode',
  BASKETBALL: 'basketball',
  BEACH: 'beach',
  BEGINNER_SPORTIVE: 'beginner-sportive',
  BIKE_RENTAL: 'bikeRental',
  BOLDER_ARROW_FORTH: 'bolderArrowForth',
  BOLDER_ARROW_FORTH_LEFT: 'bolderArrowForthLeft',
  BOLDER_ARROW_FORTH_DOWN: 'bolderArrowForthDown',
  BOLDER_ARROW_FORTH_WITH_TAIL: 'bolderArrowForthWithTail',
  BOUTIQUE: 'boutique',
  BUSINESS_CLASS: 'businessClass',
  CAR: 'car',
  CARDIO_TRAINING: 'cardioTraining',
  CAR_PARK: 'carpark',
  CHECK: 'check',
  CHECKBOX_CHECKED: 'checkboxChecked',
  CHECKBOX_UNCHECKED: 'checkboxUnchecked',
  CHILDCARE: 'childcare',
  CHILDREN: 'children',
  CHRONO: 'chrono',
  CIRCLED_ACCOMMODATION: 'circledAccommodation',
  CIRCLED_CROSS: 'circledCross',
  CIRCLED_PLANE: 'circledPlane',
  CLIMBING: 'climbing',
  CLOSED_EYE_PASSWORD: 'closedEyePassword',
  CLUBMED: 'clubmed',
  CLUBMED_ALL_INCLUSIVE_LARGE: 'clubmedAllInclusiveLarge',
  CLUBMED_ALL_INCLUSIVE_SMALL: 'clubmedAllInclusiveSmall',
  CLUBMED_EXCLUSIVE: 'ClubMedExclusive',
  CLUBMED_EXCLUSIVE_DIGITAL: 'digital_EC',
  CLUBMED_GM: 'clubmedGM',
  CLUBMED_GM_FEEDBACK: 'ClubMedGreatMemberFeedBack',
  CLUBMED_GREAT_MEMBERS_INTRO: 'clubMedGreatMembersIntro',
  CLUBMED_GREAT_MEMBERS_GOLD: 'GreatMembersGold',
  CLUBMED_GREAT_MEMBERS_PLATINUM: 'GreatMembersPlatinum',
  CLUBMED_GREAT_MEMBERS_SILVER: 'GreatMembersSilver',
  CLUBMED_GREAT_MEMBERS_TURQUOISE: 'GreatMembersTurquoise',
  CLUBMED_GREAT_MEMBERS_WITH_SHADOW: 'GreatMembersWithShadow',
  CLUBMED_JOBS: 'clubmedJobs',
  CLUBMED_JOYVIEW: 'clubmedJoyView',
  CLUBMED_MEETINGS: 'clubmedMeetings',
  CLUBMED_PLUS: 'clubmedPlus',
  CLUBMED_PROPERTY: 'clubmedProperty',
  COMMUNITY: 'wibilongIcon',
  CONNECT: 'connect',
  COMPASS: 'compass',
  CONNECTION_INFO: 'connection-information',
  CONFIRMATION: 'confirmation',
  CONTACT: 'contact',
  COUPLE: 'couple',
  CREACTIVE: 'creactive',
  CREDIT_CARD: 'creditcard',
  CROSS: 'cross',
  CRUISE: 'cruise',
  CULTURE_DISCOVERY: 'culture-discovery',
  DANCE: 'dance',
  DATE: 'date',
  DATE_PLUS: 'datePlus',
  DATE_STAR: 'dateStar',
  DISCONNECTION: 'disconnection',
  DESTINATION: 'destination',
  DETAILS: 'details',
  DISCOVERY_CENTER: 'discovery-center',
  DISHES: 'dishes',
  DIVING: 'diving',
  DOCUMENT: 'document',
  DOCUMENT_COLORED: 'documentColored',
  DONATION: 'donation',
  DOWNLOAD: 'download',
  DRESSCODE: 'dresscode',
  DURATION: 'duration',
  EARTH: 'earth',
  EARTH_PLANE: 'earthPlane',
  EASY_ARRIVAL_TITLE: 'easyArrivalTitle',
  ESPRESSO: 'espresso',
  EXCLUSIVE_COLLECTION: 'exclusiveCollection',
  EYE_PASSWORD: 'eyePassword',
  ENTERTAINMENT: 'entertainment',
  FACEBOOK: 'facebook',
  FAT_DOT: 'fatDot',
  FAMILY: 'family',
  FITNESS: 'fitness',
  FOLDER: 'folder',
  FOOTBALL: 'football',
  GOLF: 'golf',
  GREAT_CHECK: 'greatCheck',
  HAIRDRESSER: 'hairdresser',
  HAMBURGER: 'hamburger',
  HAPPY_ARRIVAL: 'happyArrival',
  HAPPY_FIRST: 'happyFirst',
  HEALTH: 'health',
  HOME: 'home',
  ICON_45: '45',
  IDEAL_FOR_FAMILY: 'idealForFamily',
  INTERNET: 'internet',
  INFORMATION: 'information',
  INFORMATION_FILLED: 'informationFilled',
  INSURANCE: 'insurance',
  INSTAGRAM: 'instagram',
  JOYVIEW_HAND: 'flexible',
  JUNIOR: 'junior',
  KAYAK: 'kayak',
  KITESURF: 'kitesurf',
  LEFT_ARROW: 'leftArrow',
  LEISURE_AND_RELAXATION: 'leisure_and_relaxation',
  LEVEL: 'level',
  LIGHTBULB: 'lightbulb',
  LUGGAGE: 'luggage',
  MAGNIFY_GLASS: 'magnifyingGlass',
  MAIL: 'mail',
  MANAGE: 'manage',
  MAP_MINUS: 'map_minus',
  MAP_PLUS: 'map_plus',
  MAP_ROTATE_LEFT: 'map_rotate_left',
  MAP_ROTATE_RIGHT: 'map_rotate_right',
  MAXIMIZE: 'maximize',
  MEETINGS_EVENTS: 'meetingsevents',
  MINI_CLUB: 'miniClub',
  MINIMIZE: 'minimize',
  MINUS: 'minus',
  MOBILE: 'mobile',
  MOUNTAIN: 'winterMountainResorts',
  MUSCULATION: 'musculation',
  MUST_TRY_EXPERIENCES: 'mustTryExperiences',
  MUST_TRY_EXPERIENCES_FR: 'mustTryExperiences-fr',
  NATURE: 'nature',
  NEW: 'new',
  NEWSLETTER: 'newsletter',
  NORDIC_WALKING: 'walking',
  NO_STOP: 'noStop',
  NO_TRANSPORT: 'noTransport',
  NOTEBOOK: 'notebook',
  ON_DEMAND: 'onDemand',
  OPTION: 'option',
  PADLOCK: 'padlock',
  PASSPORT: 'passport',
  PASSWORLD: 'passworld',
  PAYMENT_PLAN: 'paymentPlan',
  PDF: 'pdf',
  PEN: 'pen',
  PEOPLE: 'people',
  PERCENTAGE: 'percentage',
  PETANQUE: 'petanque',
  PETIT_CLUB: 'petitClub',
  PHONE: 'phone',
  PHONE_BUBBLE: 'phoneBubble',
  PHOTO_ALBUM: 'photoAlbum',
  PIN_AMENITY: 'pin_amenity',
  PIN_ROOM: 'pin_room',
  PIN_ROOM_HIGHLIGHT: 'pin_room_highlight',
  PLANE_AND_CIRCLE: 'planeAndCircle',
  PLUS: 'plus',
  PLANE_COMFORT: 'planeComfort',
  POOL_TOWELS: 'pool-towels',
  PROMO_CODE: 'promoCode',
  QUOTATION_MARK: 'quotationMark',
  QUESTION: 'question',
  RECEPTION: 'reception',
  REVERSE_CLOCK: 'reverseClock',
  RECEIPT: 'receipt',
  RIDING: 'riding',
  ROOM: 'room',
  ROOMS: 'rooms',
  RESET: 'reset',
  ROLLER: 'roller',
  SAILING: 'sailing',
  SAND_GLASS: 'sandglass',
  SEARCH_GLASS: 'searchGlass',
  SECURE_KEY: 'secureKey',
  SELECT: 'select',
  SELECT_UP: 'selectUp',
  SETTINGS: 'settings',
  SIGNOUT: 'signout',
  SIZE: 'size',
  SKI: 'ski',
  SKI_AND_POLES: 'skiAndPoles',
  SKI_IN_OUT: 'ski_in_out',
  SKI_EQUIPMENTS: 'skiEquipments',
  SMALL_CIRCLE_CHECK: 'smallCircleCheck',
  SMALL_WARNING: 'smallWarning',
  SNORKELLING: 'snorkelling',
  SNOWBOARD: 'snowboard',
  SNOWBOARD_SKIN: 'snowboardSkin',
  SPA: 'spa',
  SPECIAL_OFFERS: 'specialOffers',
  SPORT: 'sport',
  STANDALONE_MAGNIFYING_GLASS: 'StandaloneMagnifyingGlass',
  STOP_MARKER: 'stopMarker',
  SPORT_SCHOOL: 'sport_school',
  STAND_UP_PADDLE: 'stand_up_paddle',
  STORELOCATOR: 'storeLocator',
  STRAIGHT_CHECK: 'straightCheck',
  SUMMARY: 'summary',
  SUN: 'sun',
  SURF: 'surf',
  SWIM: 'swim',
  TABLE_TENNIS: 'table-tennis',
  TAKE_OFF: 'takeOff',
  TENNIS: 'tennis',
  TOOLTIP: 'tooltip',
  TOUR: 'tour',
  TRANSFER: 'transfer',
  TRANSPORT: 'transport',
  TRAPEZE: 'trapeze',
  TREETOP_ADVENTURE: 'treetop_adventure',
  TRIDENT: 'trident', // used as prefix,
  TRIDENT1: 'trident1',
  TRIDENT2: 'trident2',
  TRIDENT3: 'trident3',
  TRIDENT4: 'trident4',
  TRIDENT5: 'trident5',
  TRIDENT6: 'trident6',
  TRIDENT45: 'trident45',
  TRIDENT_JOYVIEW: 'tridentjoyview',
  TRAIN: 'train-transport',
  BOAT: 'boat',
  URGENTISATION: 'urgentisation',
  USER: 'user',
  USERS: 'users',
  VIDEOS: 'videos',
  VIDEOS_360: 'videos360',
  VOLLEYBALL: 'volleyball',
  VTT: 'vtt',
  WALKING: 'walking',
  WARNING: 'warning',
  WATERSKI: 'waterski',
  WECHAT: 'wechat',
  WEIGHT: 'weight',
  WELL_BEING: 'well-being',
  WHATSAPP: 'whatsapp',
  WINDSURFING: 'windsurfing',
  WINE_CELLAR: 'wineCellar',
  WINTER_MOUNTAIN: 'winterMountainResorts',
  YOGA: 'yoga',
  ZEN_ZONE: 'zenzone',
  HEART: 'heart',
  HEART_FILLED: 'heartFilled',
  SHARE: 'share',
  SHARE_LINK: 'share_link',
  SHARE_WHATSAPP: 'share_whatsapp',
  SHARE_SMS: 'share_sms',
  SHARE_MESSENGER: 'share_messenger',
  SMALL_CHECK: 'smallCheck',
  SMALL_CROSS: 'smallCross',

  // Safe Together icons
  SAFE_TOGETHER_INSURANCE: 'stInsurance',
  SAFE_TOGETHER_REDUCED_CAPACITY: 'reducedCapacity',
  SAFE_TOGETHER_DISTANCING: 'distancing',
  SAFE_TOGETHER_CAUGH: 'cough',
  SAFE_TOGETHER_APP: 'app',
  SAFE_TOGETHER_SOCIAL_DISTANCING: 'socialDistancing',
  SAFE_TOGETHER_DOCTOR: 'doctor',
  SAFE_TOGETHER_GLOVES: 'gloves',
  SAFE_TOGETHER_MASK: 'mask',
  SAFE_TOGETHER_RECEPTION_MASK: 'receptionMask',
  SAFE_TOGETHER_RESTAURANT_MASK: 'restaurantMask',
  SAFE_TOGETHER_HAND_SHAKE: 'handsShake',
  SAFE_TOGETHER_SKI_ROOM: 'skiRoom',
  SAFE_TOGETHER_SOAP: 'stSoap',
  SAFE_TOGETHER_SOLUTION: 'solution',
  SAFE_TOGETHER_SPA_MASK: 'spaMask',
  SAFE_TOGETHER_WASH: 'wash',
  SAFE_TOGETHER_DISINFECTION: 'disinfection',
  SAFE_TOGETHER_TEMPERATURE: 'temperature',

  // Accations categories
  '000017': 'dmd_club',
  '000048': 'dmd_club', // Club Famille Plage Vue Mer
  '000061': 'dmd_superior',
  '000018': 'dmd_deluxe',
  '000020': 'dmd_suite', // Deluxe Communicante Espace 5 Tridents
  '000021': 'dmd_deluxe', // Deluxe Espace 5 Tridents
  '000039': 'dmd_deluxe', // Deluxe Zen
  '000047': 'dmd_deluxe', // Deluxe Famille Plage Vue Mer
  '000056': 'dmd_deluxe', // Deluxe Exclusive
  '000019': 'dmd_suite',

  // Accommodation rooms
  SINGLE_ROOM: 'single',
  SUITE_ROOM: 'suite',
  SEPARATE_ROOMS: 'separate',
  SEPARATE_ROOMS_3: 'separate3',
  CONNECTING_ROOMS: 'connecting',
  SEPARATED_BUILDINGS: 'separated_buildings',
  SHARED_ROOM: 'shared_room',
  CONFIGURATION: 'keys',
  COMFORT: 'starlist',
  EXTRA_FEATURES: 'doorhanger',

  // Accommodation arrangements
  BABY: 'repartition-baby',

  // Accommodation strengths
  beach_side: 'beach',
  Balcony: 'balcony',
  furnished_balcony: 'balcony',
  double_balcony: 'double-balcony',
  furnished_terrace: 'furnished-terrace',
  garden_side: 'garden_side',
  lakeside: 'lakeside',
  lounge: 'lounge-area',
  lounge_area: 'lounge-area',
  poolside: 'poolside',
  private_furnished_terrace: 'private-furnished-terrace',
  private_garden: 'private-garden',
  private_pool: 'private-pool',
  sea_side: 'sea_side',
  separate_rooms: 'separate',
  separate_sleeping_area_for_the_kids: 'kids-sleeping-area',
  terrace: 'terrace',
  fir_tree_view: 'fir-tree-view',
  garden_view: 'garden_view',
  golf_view: 'golf-view',
  mountain_view_or_slopes_view: 'mountain-view',
  mountain_view: 'mountain-view',
  pool_view: 'pool-view',
  river_view: 'river-view',
  seaview: 'seaview',
  sea_view: 'sea_side',
  slopes_view: 'slopes-view',
  valley_view: 'valley-view',
  view_chailifts_or_cable_railway: 'chairlifts',
  view_of_the_grounds: 'grounds',
  view_of_the_ski_resort: 'ski-resort',
  with_balcony_or_resort_view: 'balcony',
  baby_bed: 'baby-bed',
  reduced_mobility_access: 'pmr',

  // Accommodation equipments
  MAT_000008: 'ac', // Climatisation
  MAT_000399: 'homecinema', // Home cinema
  MAT_000400: 'stereo', // Stereo system with speaker extensions on veranda
  MAT_000401: 'shower', // Outdoor shower
  MAT_000411: 'saferoom', // "Safe" room reserved for the owner
  MAT_000412: 'skilocker', // Private ski locker at the entrance to your Chalet-Appartment
  MAT_000413: 'ventilatedlocker', // Ventilated locker equipped for drying ski boots
  MAT_000421: 'dvd', // DVD / Blu-Ray player
  MAT_000422: 'mosquitos', // Anti-mosquito plug
  MAT_000430: 'rainshower', // Shower room with rain shower
  MAT_000491: 'minifridge', // Minibar (in Suite only)
  MAT_000285: 'americanfridge', // American fridge freezer
  MAT_000280: 'lounge-area', // Armchair
  MAT_000407: 'electricity', // Asian electrical sockets (100 volts)
  MAT_000216: 'electricity', // Asian triple electrical plugs / 220 Volts
  MAT_000174: 'electricity', // Australian electrical sockets /  220-240 Volts
  MAT_000480: 'balcony', // Balcony
  MAT_000224: 'bathrobe', // Bathrobes
  MAT_000255: 'bathtubshower', // Bathroom (with bath and shower)
  MAT_000405: 'bathtubshower', // Bathroom (with bath and/or shower)
  MAT_000448: 'bathtub', // Bathroom with bath
  MAT_000432: 'rainshower', // Bathroom with bathtub and rainfall shower
  MAT_000288: 'showerdualwashbasin', // Bathroom with shower and two washbasins
  MAT_000306: 'showertoilets', // Bathroom with toilets
  MAT_000207: 'cd', // CD player
  MAT_000297: 'cddvd', // CD player/DVD player (only in the Chateau Room)
  MAT_000274: 'coffeemaker', // Coffee machine
  MAT_000158: 'table', // Coffee tables
  MAT_000286: 'kitchenware', // Crockery, cutlery, pans etc
  MAT_000180: 'dvd', // DVD player
  MAT_000428: 'bench', // Private daybed
  MAT_000438: 'baldaquin', // Sunbath daybed with canopy
  MAT_000282: 'dishwasher', // Dish washer
  MAT_000278: 'dressing', // Dressing room
  MAT_000277: 'dressingtable', // Dressing table
  MAT_000387: 'dualcabin', // Duo treatment room(s) for tandem treatments (with shower)
  MAT_000279: 'oven', // Electric oven
  MAT_000236: 'fan', // Fan
  MAT_000292: 'raclette', // Fondue and raclette maker
  MAT_000268: 'fridge', // Fridge
  MAT_000228: 'icebucket', // Ice bucket
  MAT_000036: 'icemaker', // Ice maker
  MAT_000433: 'cd', // In-room sound system
  MAT_000284: 'induction', // Induction hot plate and kitchen hood
  MAT_000211: 'internet', // Internet
  MAT_000301: 'ironing', // Ironing kit (Deluxe Room and Suite)
  MAT_000232: 'ironing', // Ironing kit (Deluxe Room only)
  MAT_000434: 'ironing', // Ironing kit (on demand)
  MAT_000435: 'ironing', // Ironing kit (on demande - Deluxe room only)
  MAT_000460: 'ofuro', // Japenese bath (Furo)
  MAT_000275: 'juicer', // Juicer
  MAT_000291: 'kitchen', // Kitchen fitted and equipped
  MAT_000266: 'ipoddock', // MP3 player
  MAT_000264: 'microwave', // Micro-wave
  MAT_000227: 'stereo', // Mini stereo
  MAT_000290: 'stereo', // Mini stereo
  MAT_000304: 'ipoddock', // Mini stereo and iPod/MP3 docking station
  MAT_000363: 'hammam', // Mixed Turkish bath
  MAT_000178: 'musicclock', // Radio
  MAT_000271: 'musicclock', // Radio / CD / MP3 player
  MAT_000014: 'musicclock', // Radio / CD player
  MAT_000305: 'dressing', // Separate dressing room
  MAT_000283: 'sheets', // Sheets
  MAT_000298: 'accessiblebathroom', // Shower room (for the Suite suitable for people with reduced mobility)
  MAT_000436: 'dualbathroom', // Shower room ground floor and first floor
  MAT_000299: 'showerwashbasin', // Shower room with shower and one washbasin
  MAT_000463: 'showerdualwashbasin', // Shower room with shower and two washbasins
  MAT_000406: 'showertoilets', // Shower room with toilets
  MAT_000270: 'electricity', // Swiss electrical sockets / 220 volts
  MAT_000273: 'kettle', // Tea and coffee kit (only in the Deluxe Rooms)
  MAT_000243: 'beachtowel', // Towel
  MAT_000441: 'electricity', // Triple electrical sockets / 230 volts
  MAT_000429: 'electricity', // U.S and European electrical sockets / 220 Volts
  MAT_000478: 'electricity', // U.S. and Brazilian electrical sockets / 110 Volts
  MAT_000173: 'electricity', // U.S. electrical sockets /  220 Volts
  MAT_000172: 'electricity', // U.S. electrical sockets / 110 Volts
  MAT_000261: 'umbrella', // Umbrellas
  MAT_000287: 'kitchenstorage', // Worktop and cupboards
  MAT_000431: 'yogamat', // Yoga mat
  MAT_Bluethothh_room_bathroom: 'bluetoothspeaker', // Bluetooth speaker in room and bathroom
  MAT_Bluetooth_room: 'bluetoothspeaker', // Bluetooth speaker in the room
  MAT_connected_television_: 'television', // Connected television (TV with international channels, VOD, radios)
  MAT_bluetooth_sound_system: 'bluetooth', // Bluetooth sound system
  MAT_SKINJAY: 'skinjay', // SKINJAY all-natural aroma shower pod system
  MAT_italian_european_sockets_220V: 'electricity', // Italian and European electrical sockets / 220 Volts
  MAT_tea_expresso_machine: 'espresso', // Tea and Expresso machine
  MAT_slippers: 'slippers', // Slippers
  MAT_drycleaning_service_at_extra_cost: 'pressing', // Drycleaning service at extra cost
  matt_showerdoublewashbasin: 'showerdualwashbasin', // Shower with Double Washbasin
  MAT_000469: 'electricity', // Brazilian and European electrical sockets / 220 Volts
  MAT_000302: 'showerbathtub', // Bathroom and shower room
  MAT_000294: 'kettle', // Tea and coffee kit
  MAT_000470: 'bluetoothspeaker', // Bluetooth speakers
  MAT_000276: 'separatedtoilets', // Separate toilets
  MAT_safe: 'safe', // Safe
  MAT_000259: 'showerdualwashbasin', // Bathroom with double washbasin
  MAT_000214: 'kettle', // Kettle
  MAT_000289: 'bathtubshower', // Bathroom with bath, shower and double washbasin
  MAT_000500: 'bathtubtoilets', // Bathroom with bath and toilets
  MAT_000303: 'wifi', // Wifi access
  MAT_000267: 'musicclock', // Radio alarm clock / MP3 player
  MAT_000408: 'electricity', // Japanese electrical sockets / 100 volts
  MAT_000223: 'television', // Television(s)
  MAT_television: 'television', // Television
  MAT_000006: 'minifridge', // Mini fridge at your disposal
  MAT_000005: 'phoneBubble', // Telephone
  MAT_000179: 'ironing', // Iron and ironing-board
  MAT_000171: 'electricity', // European electrical sockets / 220 Volts
  MAT_000004: 'safe', // Security safe(s)
  MAT_000213: 'musicclock', // Radio alarm clock / CD player
  MAT_000181: 'espresso', // Expresso machine
  MAT_000295: 'ironing', // Ironing kit
  MAT_000272: 'minifridge', // Minibar (Deluxe Room only)
  MAT_000293: 'minifridge', // Minibar
  MAT_000011: 'washingmachine', // Washing machine
  MAT_000501: 'bathtub', // Bathroom with bath and double washbasin
  MAT_000245: 'shower', // Shower
  MAT_000244: 'toweldryer', // Heated towel rail
  MAT_000012: 'dryer', // Tumble dryer
  MAT_000202: 'musicclock', // Radio alarm clock
  MAT_000002: 'hairdryer', // Hair dryer
  MAT_000246: 'bathtubshower', // Bathroom
  MAT_000260: 'bathtubshower', // Shower room or bathroom
  MAT_000426: 'electricity', // Triple British electrical sockets / 220 volts
  MAT_000466: 'minifridge', // Mini bar refreshed daily with soft drinks
  MAT_baby_bed: 'baby-bed', // Baby bed
  MAT_baby_welcome_pack: 'baby-welcome', // Baby welcome
  MAT_AC__heating: 'ac', // Air condition
  MST_ACT_SERLGT_000313: 'champagne', // Champagne available in the private lounge
  MST_ACT_SERLGT_000330: 'shampoo', // Welcoming luxury products (shampoo, shower gel, cream, etc.)
  MST_ACT_SERLGT_000338: 'priorityspa', // Priority booking at the Club Med Spa
  MST_ACT_SERLGT_000339: 'snacks', // Private bar and snacking service at the caretaker's loge
  MST_ACT_SERLGT_000418: 'laundry', // Laundry service
  MST_ACT_SERLGT_000439: 'beachtowel', // Beach towel
  MST_ACT_SERLGT_SKINJAY: 'skinjay', // SKINJAY all-natural aroma shower pod system
  MST_ACT_SERLGT_000323: 'slippers', // Slippers
  MAT_socket_type_E: 'electricity', // Prises électriques type E: 220 - 240 V
  MAT_sofa_couch: 'bench', // Canapé
  separate_living_room: 'lounge-area',
  MAT_tea_making_facilities: 'kettle', // Nécessaire à thé
  MST_ACT_SERLGT_000308: 'transfer', // Transfert pour les G.M® avec le Forfait séjour et transport
  MST_ACT_SERLGT_000321: 'luggagetransport', // Prise en charge des bagages en chambre
  MST_ACT_SERLGT_000327: 'bathrobe', // Peignoir
  MST_ACT_SERLGT_000342: 'amenities_laundry', // Service de nettoyage à sec (à la carte)
  MST_ACT_SERLGT_000449: 'luggagetransport', // Prise en charge des bagages
  MST_ACT_SERLGT_000450: 'luggagetransport', // Prise en charge des bagages
  typeoflodging_bathroom_facilities_hair_dryer: 'hairdryer', // Sèche-cheveux
  MAT_socket_type_b___100_127_v: 'electricity', // Prise électrique type B : 100-127 V
  MST_ACT_SERLGT_000310: 'amenities', // Produits d'accueil (shampoing, gel douche, crème etc.) de marque
  MST_ACT_SERLGT_000312: 'welcomegift', // Cadeau de bienvenue
  MST_ACT_SERLGT_000314: 'champagne', // Champagne à disposition dans le lounge privé (18h-23h)
  MST_ACT_SERLGT_000317: 'lunch', // Déjeuner offert en cas d'arrivée avant 15h
  MST_ACT_SERLGT_000328: 'people', // Personnel spécialement dédié
  MST_ACT_SERLGT_000329: 'swimmingpool', // Piscine réservée aux G.M® logés dans des Suites
  MST_ACT_SERLGT_000333: 'room-service', // Room service
  MST_ACT_SERLGT_000336: 'room-service', // Room service du petit déjeuner continental inclus
  MST_ACT_SERLGT_000416: 'beachtowel', // Serviette de plage
  MST_ACT_SERLGT_000440: 'minifridge', // Minibar (approvisionnement quotidien)
  MST_ACT_SERLGT_000454: 'room-service', // Room service de 7h00 à 23h00
  MST_ACT_SERLGT_priority_specialty_restaurant: 'restaurant', // Réservation prioritaire au Restaurant de Spécialités
  MST_ACT_SERLGT_priority_booking_gourmet_lounge: 'dishes', // Réservation prioritaire au "Lounge Gourmet"
  MST_ACT_SERLGT_room_service_asian_continental_breakfast: 'room-service', // Room service du petit-déjeuner
  MST_PRE_003589: 'baby-welcome', // Club Med Baby Welcome® (4 à 23 mois)
  MAT_minibar_refilled_weekly: 'minifridge', // Minibar (approvisionnement hebdomadaire)
  MAT_socket_type_C: 'electricity', // Prises électriques type C: 200 - 240 V
  MAT_universal_adaptator: 'electricity', // Adaptateur universel dans la chambre
  typeoflodging_bathroom_facilities_shower: 'shower', // Douche
  typeoflodging_bathroom_facilities_double_washbasin: 'showerdualwashbasin', // Double Vasque
  typeoflodging_bathroom_facilities_bathrobes: 'bathrobe', // Peignoir
  typeoflodging_bathroom_facilities_slippers: 'slippers', // Chaussons
  typeoflodging_bathroom_facilities_magnifying_mirror: 'beauty-mirror', // Miroir de beauté
  typeoflodging_bathroom_facilities_branded_amenities: 'amenities', // Produits d'accueil (shampoing, gel douche, crème etc.) de marque
  typeoflodging_outside_facilities_furnished_terrace: 'furnished-terrace', // Terrasse aménagée
  typeoflodging_outside_facilities_furnished_balcony: 'balcony', // Balcon aménagé
  typeoflodging_bathroom_facilities_separate_toilets: 'separatedtoilets', // Toilettes séparées
  MST_ACT_SERLGT_premium_wifi: 'internet', // Wi-Fi premium
  typeoflodging_bathroom_facilities_bath: 'bathtub', // Baignoire
  typeoflodging_bathroom_facilities_separate_bathroom: 'bathroom', // Salle de bains séparée
  typeoflodging_bathroom_facilities_accessories_amenities: 'amenities', // Produits d'accueil: accessoires ( bonnet de douche, vanity kit , kit manucure etc...)
  MST_PRE_003931: 'beachtowel', // Serviette de plage
  typeoflodging_bathroom_facilities_heated_towel_rail: 'toweldryer', // Sèche-serviettes
  typeoflodging_outside_facilities_balcony: 'balcony', // Balcon
  MST_ACT_SERLGT_ROOM: 'room-service', // Room service de 7h00 à 22h00
  MST_ACT_SERLGT_000322: 'luggagetransport', // Prise en charge des bagages en chambre
  MST_ACT_SERLGT_000309: 'internet', // Accès Wi-Fi
  typeoflodging_outside_facilities_private_furnished_terrace: 'furnished-terrace', // Terrasse privative aménagée
  MAT_socket_type_L: 'electricity', // Prises électriques type L: 200 - 240 V
  typeoflodging_outside_facilities_terrace_or_balcony: 'terrace', // Balcon ou terrasse
  MAT_socket_type_O: 'electricity', // Prises électriques type O: 220 - 240 V
  typeoflodging_outside_facilities_private_pool: 'private-pool', // Terrasse avec Piscine privative
  MST_ACT_SERLGT_000335: 'room-service', // Room service (à certains horaires)
  typeoflodging_outside_facilities_terrace: 'terrace', // Terrasse
  MAT_socket_type_I: 'electricity', // Prises électriques type I : 220 - 240 V
  MAT_Minibar_daily_refilled_in_the_Suite_only: 'minifridge', // Minibar (réapprovisionné quotidiennement dans la Suite uniquement)
  MAT_minibar_daily_refilled_in_the_deluxe: 'minifridge', // Minibar (approvisionnement quotidien dans la Deluxe seulement)
  typeoflodging_outside_facilities_private_garden: 'furnished-terrace', // Terrasse aménagée avec Jardin privatif
  MAT_air_conditioning: 'ac', // Air conditionné
  MST_ACT_SERLGT_laundry_service_a_la_carte: 'pressing', // Service de blanchisserie (à la carte)
  MAT_000157: 'daybed', // Transats
  MAT_000380: 'hammam', // Douche double hammam
  MST_ACT_ROOM_SERVICE_CONTINENTAL_JAPANESE_KOREAN_BREAKFAST: 'room-service', // Room service du petit-déjeuner continental, Chinese, Japanese, and Korean
  MST_ACT_champagne_manta_lounge: 'champagneglass', // Champagne à disposition dans le lounge privé (18h-23h)
  MST_PRE_002582: 'internet', // Accès Wi-Fi
  MST_ACT_SERLGT_champagne_6pm_bar: 'champagneglass', // Champagne servi à la flûte à 18h00 au bar
  MAT_family_room_with_curtain_between_adult_zone_kid: 'baldaquin', // Chambre avec  un rideau séparant la zone nuit adultes et la zone nuit enfants
  MST_ACT_SERLGT_BLUETOOTH: 'bluetoothspeaker', // Enceintes Bluetooth
  typeoflodging_outside_facilities_double_balcony: 'double-balcony', // Double Balcon
  MST_ACT_SERLGT_000311: 'waterbottle', // Bouteille d'eau
  MST_ACT_SERLGT_000341: 'bednight', // Préparation de la chambre pour la nuit
  MST_ACT_SERLGT_000483: 'household', // Service de ménage
  MST_ACT_SERLGT_000326: 'household', // Ménage fait à l'heure de votre convenance
  MST_ACT_SERLGT_000340: 'room-service', // Service de conciergerie
  MST_ACT_SERLGT_000324: 'household', // Ménage de la Suite fait à l'heure de votre convenance
  MST_ACT_SERLGT_pool_towel: 'pool-towels', // Serviette de piscine
  MST_ACT_SERLGT_Private_transfert_package_1: 'privateTransfer',
  MST_ACT_SERLGT_upgrade_transfer_package: 'privateTransfer',
  MST_ACT_SERLGT_covered_parking_space: 'parking',
  MST_ACT_SERLGT_mountain_diner: 'mountain-diner',
  MST_ACT_SERLGT_shuttle_service_to_the_resort: 'shuttleBus',
  MAT_fireplace: 'fireplace',
  MST_private_ski_room: 'private-ski', // Espace ski privé
  MST_ACT_SERLGT_000318: 'dedicated', // Interlocuteur dédié pour le séjour
  MAT_outdoor_private_bath__on_terrace_or_balcony: 'private-bathroom', // Bain privé extérieur sur terrasse ou balcon
  MAT_magnifying_mirror: 'beauty-mirror', // Miroir de beauté
  MST_ACT_SERLGT_cinq_mondes_amenities: 'amenities', // Produits d'accueil CINQ MONDES
  MST_ACT_SERLGT_concierge_dedicated_contact: 'room-service', // Service de conciergerie
  MAT_equipment_usb_socket: 'usb', // Prise USB
  MST_turn_down_service: 'bednight', // Préparation de la chambre pour la nuit
  MST_ACT_SERLGT_cleaning_on_demand: 'household', // Service de ménage à l'heure de votre convenance
  MST_breakfast_in_room: 'room-service', // Breakfast in-room
  MST_ACT_SERLGT_ROOM_SERVICE_COST: 'room-service', // Zimmerservice (gegen Aufpreis) von 11.00 bis 11.00 Uhr
  MST_ACT_SERLGT_room1_service_included: 'room-service', // Zimmerservice von 11 bis 23 Uhr
  MST_ACT_SERLGT_expresso_machine: 'espresso', // Expresso Machine
  MST_ACT_SERLGT_mp3_player: 'musicclock', // MP3 player

  // Products
  AEXC: 'aexc',
  AGAC: 'agac',
  AHSC: 'ahsc',
  ALBC: 'albc',
  ALBV: 'albv',
  ALHC: 'alhc',
  ANJJ: 'anjj',
  APLC: 'aplc',
  ARPC: 'arpc',
  AVOC: 'avoc',
  BALC: 'balc',
  BEIC: 'beic',
  BODC: 'bodc',
  BUCC: 'bucc',
  CANC: 'canc',
  CARC: 'carc',
  CERC: 'cerc',
  CFAC: 'cfac',
  CGBJ: 'cgbj',
  CHAC: 'chac',
  CHEC: 'chec',
  CM2C: 'cm2c',
  COLC: 'colc',
  CRGC: 'crgc',
  CSKC: 'cskc',
  DALC: 'dalc',
  DAOC: 'daoc',
  DBAC: 'dbac',
  DDOC: 'ddoc',
  GMAC: 'gmac',
  GMAV: 'gmav',
  GREC: 'grec',
  GRWJ: 'grwj',
  GUIC: 'guic',
  ITAC: 'itac',
  IXTC: 'ixtc',
  KABC: 'kabc',
  KAHC: 'kahc',
  KAMC: 'kamc',
  KANC: 'kanc',
  KANV: 'kanv',
  KEMC: 'kemc',
  LAPC: 'lapc',
  LPAC: 'lpac',
  LROC: 'lroc',
  MANC: 'manc',
  MAUC: 'mauc',
  MCHC: 'mchc',
  MMAC: 'mmac',
  MPAC: 'mpac',
  MPEC: 'mpec',
  NAPC: 'napc',
  OPIC: 'opic',
  PAHC: 'pahc',
  PALC: 'palc',
  PCAC: 'pcac',
  PHUC: 'phuc',
  PLAC: 'plac',
  PRAC: 'prac',
  PVAC: 'pvac',
  QCHC: 'qchc',
  RBIC: 'rbic',
  RDPC: 'rdpc',
  SAMC: 'samc',
  SANC: 'sanc',
  SAOC: 'saoc',
  SAYC: 'sayc',
  SCHC: 'schc',
  SEYC: 'seyc',
  SIBC: 'sibc',
  SMRC: 'smrc',
  TOMC: 'tomc',
  TRAC: 'trac',
  TURC: 'turc',
  TVCC: 'tvcc',
  VERC: 'verc',
  VISC: 'visc',
  VLPC: 'vlpc',
  VMOC: 'vmoc',
  VMOV: 'vmov',
  VSOC: 'vsoc',
  VTHC: 'vthc',
  YABC: 'yabc',
  YANJ: 'yanj',
  YASC: 'yasc',

  // Childcare equipments
  equipment_CHILD_blender_adapted_for_babies: 'blender',
  equipment_CHILD_microwawe_oven: 'microwave',
  equipment_CHILD_refrigerators: 'fridge',
  equipment_dishes_adapted_for_babies: 'spoon',
  equipment_CHILD_baby_body_soap: 'soap',
  equipment_CHILD_biscuits: 'biscuit',
  equipment_CHILD_bottle_warmer: 'babyBottleHeater',
  equipment_CHILD_bottle_wash_dispenser: 'soapDispenser',
  equipment_CHILD_bowls_and_containers: 'bowls',
  equipment_CHILD_brushes__cleaning_bottles_and_teats: 'bottleBrush',
  equipment_CHILD_dishwater: 'dishwasher',
  equipment_CHILD_dispenser_hand_towels: 'paperDispenser',
  equipment_CHILD_disposable_cutlery: 'disposableSilverware',
  equipment_CHILD_flat_plates_and_shallow_dishes: 'plates',
  equipment_CHILD_fruit_juice_trays: 'fruitJuice',
  equipment_CHILD_fruits_basket: 'fruitBasket',
  equipment_CHILD_long_life_semiskimmed_milk: 'skimMilk',
  equipment_CHILD_long_life_whole_milk: 'wholeMilk',
  equipment_CHILD_entier_longue_conservation: 'wholeMilk',
  equipment_CHILD_manual_fruit_press: 'manualJuicer',
  equipment_CHILD_microwawe_dishes: 'microwaveDishes',
  equipment_CHILD_mixer: 'blender',
  equipment_CHILD_plastic_or_fabric_bibs: 'bib',
  equipment_CHILD_sink: 'sink',
  equipment_CHILD_sterilisers: 'sterilizer',
  equipment_CHILD_still_water: 'waterbottle',
  equipment_CHILD_sugar_and_chocolate_powder: 'cocoaPowder',
  equipment_CHILD_wastebaskets: 'trashCan',
  equipment_CHILD_bathtub: 'bathtub',
  equipment_CHILD_changing_table: 'changingMat',
  equipment_CHILD_stroller_for_the_room_with_name_tag: 'stroller',
  equipment_CHILD_stroller_for_baby: 'stroller',
  equipment_CHILD_nappy_bin: 'trashCan',
  equipment_CHILD_lit_parapluie: 'baby-bed',
  equipment_CHILD_water_bottles: 'waterbottle',
  equipment_CHILD_baby_oil: 'oil',
  equipment_CHILD_antibacterial_soap_dispenser: 'soapDispenser',
  equipment_CHILD_Potty: 'potty',
  equipment_CHILD_baby_body_milk: 'lotion',
  equipment_CHILD_baby_powder: 'babyPowder',

  // ON DEMAND EQUIPMENTS
  BABYSITTING: 'babySitting',
  PAJAMAS: 'pajamas',
  TEENSPA: 'spa',
  SWIMMINGPOOL: 'swimmingpool',

  // OTHERS
  ALL_INCLUSIVE_WITH_SHADOW: 'allInclusiveWithShadow',
  CALLMEBACK: 'callMeBack',
  CHARMPRESTIGE: 'charmprestige',
  CIRCLED_CHECK: 'circledCheck',
  CLUBMED_ALL_INCLUSIVE_LARGE_CHINA: 'clubmedAllInclusiveLargeChina',
  CLUBMED_ALL_INCLUSIVE_SMALL_CHINA: 'clubmedAllInclusiveSmallChina',
  CLUBMED_COLLECTIVITES: 'clubmedcollectivites',
  CLUBMED_GREAT_MEMBER: 'clubmedGreatMember',
  CLUBMED_LOGO_GREAT_MEMBERS_TRADE: 'clubmedLogoGreatMembersTrade',
  DMD_STANDARD: 'dmd_standard',
  DOLLAR: 'dollar',
  DOUBAN: 'douban',
  EARLYSUN: 'earlySun',
  EASY_ARRIVAL: 'luggagetransport',
  FAQ: 'faq',
  FLEXIBLE_WITH_SHADOW: 'flexibleWithShadow',
  FLICKR: 'flickr',
  GARDEN: 'garden',
  GENTILBOT: 'gentilbot',
  GOOGLEPLUS: 'googleplus',
  INTRO_TRIDENT: 'introTrident',
  KIDS: 'kids',
  LATESUN: 'lateSun',
  LUGGAGE_TRANSPORT: 'lateSun',
  MAILREVERSE: 'mailReverse',
  MICROPHONE: 'microphone',
  MIXABLE: 'mixable',
  MOBILEAPP: 'mobileapp',
  MOON: 'moon',
  OVERFLOWINGPOOL: 'overflowingpool',
  PEOPLEBABY: 'peoplebaby',
  PINROOM: 'pinroom',
  PINROOMHIGHLIGHT: 'pinroomhighlight',
  REPARTITION_ADULT_EXP: 'repartitionAdultExp',
  REPARTITION_BABY_EXP: 'repartitionBabyExp',
  REPARTITION_CHILD_EXP: 'repartitionChildExp',
  RESORTHOUSE: 'resortHouse',
  RESORTSADULTS: 'resortsAdults',
  SEA: 'sea',
  SOCIAL: 'social',
  SPONSORSHIP: 'sponsorship',
  SPORT_LEISURE_AND_RELAXATION: 'sport_leisure_and_relaxation',
  train: 'train',
  USERTALK: 'usertalk',
  VINE: 'vine',
  VKONTAKTE: 'vkontakte',
  WECHATPAYMENT: 'wechatPayment',
  WEIBO: 'weibo',
  WELLNESS: 'wellness',
  WENC: 'wenc',
  WIFI: 'wifi',
  YOUTUBE: 'youtube',
};
